export const NOTIFICATION_SHOWN_EVENT = "Notification Shown"
export const NOTIFICATION_DISMISSED_EVENT = "Notification Dismissed"
